import { render } from "./aiHome.vue?vue&type=template&id=bff6b648&scoped=true"
import script from "./aiHome.vue?vue&type=script&lang=js"
export * from "./aiHome.vue?vue&type=script&lang=js"

import "./aiHome.vue?vue&type=style&index=0&id=bff6b648&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bff6b648"]])

export default __exports__